import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {GoogleAnalyticsService} from "../../services/google-analytics/google-analytics.service";
import {UserSubscription} from "../../../user/user-subscription";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import * as fromStore from "../../../store";
import {first, switchMap, takeUntil} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../store";
import {Subject} from "rxjs";
import {combineLatest} from "rxjs";
import {User} from "../../../user/user";
import {DbModalService} from "../../../modules/modal/modal";
import {DbTextPipe} from "../../pipes/db-text.pipe";
import {LowerCaseSpecificWordsPipe} from "../../pipes/lowerCaseSpecificWords.pipe";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {TypeUtils} from "../../../shared/utils/type-utils";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {Utils} from "../../../shared/utils/utils";
import {UserService} from "../../../user/user.service";
import {OneMonthFreeComponent} from "../../../shared/components/dialogs/one-month-free/one-month-free.component";

@Component({
    selector: 'db-ai-builder-demo-banner',
    templateUrl: './ai-builder-demo-banner.component.html',
    imports: [
        DbTextPipe,
        LowerCaseSpecificWordsPipe,
        NgClass,
        NgForOf,
        NgIf
    ],
    styleUrls: ['./ai-builder-demo-banner.component.scss']
})
export class AiBuilderDemoBannerComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() imgSrc: string;
  @Input() class?: string;
  @Input() from?: string;
  @Input() features: any = [];
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  public subscription: UserSubscription;
  public user: User;
  demoUser = false;
  campaignInfo: any;

  constructor(
    private _dialogService: DialogService,
    private _store: Store<DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _modalService: DbModalService,
    private _userService: UserService,
  ) {}

  ngOnInit() {
    this.campaignInfo = this._userService.getCampaignInfo();
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        first((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getUserSubscription)
          )
        ),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([user, userSubscription]) => {
        this.demoUser = Utils.isDemoUser(userSubscription, user);
        this.user = user;
        this.subscription = userSubscription;
      });
  }

  public openCheckoutDialog(): void {
    const analyticsData = {
      eventCategory: 'Free Upgrade Offer',
      eventAction: 'Locked button click',
      eventLabel: this.title
    };
    if (this.demoUser) {
      const firstTime = TypeUtils.isNull(localStorage.getItem('dbShowFirstTime'));
      const options = {
        overflowHidden: false,
        backdropClass: 'blurred',
      };
      if (!firstTime) {
        options['width'] = 1240;
      } else {
        options['width'] = 460;
        options['height'] = 600;
      }
      const modal = this._modalService.open(OneWeekFreeDemoUpgradeComponent, options);
      modal.componentInstance.showFirstTime = firstTime;
    } else {
      const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
      modal.componentInstance.mode = 'feature';
    }
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }
}
